let _state = new Map();
let self = this || window;
if (self && (self.constructor.toString() == "[object Window]" || self.constructor.name.toLowerCase() == "window")) {
    window["SMS"] = window["SMS"] || {};
    window["SMS"].getState = () => _state;
}
export class MessageStateManager {
    delete(msg) {
        _state.delete(msg.name);
    }
    get(msg) {
        return getMsgState(msg);
    }
    set(msg) {
        _state.set(msg.constructor.name, msg);
    }
}
export function getMsgState(msg) {
    return _state.get(msg.name);
}
export function getMessageStateByName(name) {
    return _state.get(name);
}
